import axios from "axios";
import { setSessionItem, getSessionItem, get_chatType } from "./chatUtility";
import { update_lastMsg } from "./timeoutUtility";

const MAKE_REQUEST_ACTIONS = {
  STORE_CHAT_RATING: "store_chat_rating",
  DIALOGFLOW: "dialogflow",
};

// Returns random 10 char lowercase alphanumeric
function get_sessionID() {
  var sessionID;

  if (getSessionItem("sessionId")) {
    sessionID = getSessionItem("sessionId");
    return sessionID;
  } else {
    // generate 10 character lowercase alphanumeric
    sessionID = Array.from(Array(10), () =>
      Math.floor(Math.random() * 36).toString(36)
    ).join("");
    setSessionItem("sessionId", sessionID);
    return sessionID;
  }
}

function get_connector_webhook() {
  if (getSessionItem("connectorWebhook")) {
    return getSessionItem("connectorWebhook");
  } else {
    return process.env.REACT_APP_WEBHOOK;
  }
}

// Format quick-reply list from dialogflow response and store in session storage
function get_quickReplies(replies_list) {
  var formatted_replies_list = [];
  for (var i = 0; i < replies_list.length; i++) {
    formatted_replies_list.push({ icon: "message", name: replies_list[i] });
  }
  setSessionItem("quickReplies", JSON.stringify(formatted_replies_list));
  return formatted_replies_list;
}

// Function to make post request to dialogflow cloud function and return response text
async function make_request(
  intent,
  sessionid = "abcde12345",
  language,
  config,
  supportActionKey = MAKE_REQUEST_ACTIONS.DIALOGFLOW,
  requestBody = {},
  warmup = false
) {
  let headerConfig = {
    headers: {
      domain: config.domain,
    },
  };
  let response = await axios.post(
    get_connector_webhook(),
    {
      INTENT: intent,
      SESSIONID: sessionid,
      language: language,
      supportActionKey: supportActionKey,
      requestBody: requestBody,
      config: config,
      warmup: warmup,
    },
    headerConfig
  );
  // Update timestamp of last message
  update_lastMsg();
  setSessionItem("chatType", "df");
  return response.data;
}

async function make_warmup_request() {
  let response = await axios.post(get_connector_webhook(), {
    warmup: true,
  });
  setTimeout(() => {
    console.log("Warmed up!!");
  }, 5000);
  return response;
}

export {
  get_sessionID,
  get_quickReplies,
  make_request,
  make_warmup_request,
  get_chatType,
};
